import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPanelCollapse = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.75 2.75H4.25C2.86929 2.75 1.75 3.86929 1.75 5.25V10.75C1.75 12.1307 2.86929 13.25 4.25 13.25H11.75C13.1307 13.25 14.25 12.1307 14.25 10.75V5.25C14.25 3.86929 13.1307 2.75 11.75 2.75Z",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.2 3V13",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 6.5L10 8L11.5 9.5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPanelCollapse;
